import { useState } from 'react';

import {
  contentAreaStyle,
  tabButtonActiveStyle,
  tabButtonStyle,
  tabContainerStyle,
  tabHeaderStyle
} from './GameTabStyles';
import Winners from './Winners';
import Contests from './Contests';
import {
  parseGameMapperId,
  triggerContestWineersTabSelect
} from 'src/utils/watchAndWinUtils';
import { useSearchParams } from 'next/navigation';

const GameTab = () => {
  const [activeTab, setActiveTab] = useState('winners');

  const searchParams = useSearchParams();
  const gameMapperId = parseGameMapperId(
    searchParams.get('game_mapper_id') || ''
  );

  const tabs = [
    { id: 'winners', label: 'Winners' },
    { id: 'contests', label: 'Contests' }
  ];

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    triggerContestWineersTabSelect(gameMapperId as string, tabId);
  };
  return (
    <>
      <div css={tabContainerStyle}>
        <div css={tabHeaderStyle}>
          {tabs.map((tab) => (
            <>
              <div
                css={[
                  tabButtonStyle,
                  activeTab == tab.id && tabButtonActiveStyle
                ]}
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}>
                {tab.id === 'winners' ? (
                  <img
                    src={`/webapp-assets/images/ILT/starIcon.svg?v=${process.env.APP_VERSION}`}
                    alt="tab-icon"
                  />
                ) : (
                  <img
                    src={`/webapp-assets/images/ILT/gameControllerIcon.svg?v=${process.env.APP_VERSION}`}
                    alt="tab-icon"
                  />
                )}
                <span>{tab.label}</span>
              </div>
            </>
          ))}
        </div>
        <div css={contentAreaStyle}>
          {activeTab === 'winners' && <Winners />}
          {activeTab === 'contests' && <Contests />}
        </div>
      </div>
    </>
  );
};

export default GameTab;
